import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { baseChipSize, getChipScale, getColor, sizes } from 'src/styles'
import { mergeProps } from 'src/util'
import { useUniqueId } from 'src/hooks'
import styles from './WinkingChip.scss'

function WinkingChip({ wink, color, badge, size, children, ...domProps }) {
  const scale = getChipScale(size)
  const radius = baseChipSize / 2
  const maskId = 'mask-' + useUniqueId()
  return (
    <svg width={baseChipSize} height={baseChipSize} className={styles.winkingChip} transform={`scale(${scale})`}>
      <g transform={`translate(${radius},${radius})`}>
        <g className={classnames({ wink })}>
          <circle
            mask={`url(#${maskId})`}
            cx="0"
            cy="0"
            r={radius}
            {...mergeProps()({ style: { fill: getColor(color) } }, domProps)}
          />
          {badge && (
            <>
              <mask id={maskId}>
                <rect x="-100%" y="-100%" width="200%" height="200%" fill="white" />
                <circle cx="40%" cy="-40%" r={radius / 2} fill="black" />
              </mask>
              <circle strokeWidth="0" cx="40%" cy="-40%" r={radius / 3} fill={getColor(badge)} {...domProps} />
            </>
          )}
          {children}
        </g>
      </g>
    </svg>
  )
}

WinkingChip.defaultProps = {
  size: 'md',
}

WinkingChip.propTypes = {
  /**
   * Whether or not the chip is winking
   */
  wink: PropTypes.bool,
  /**
   * Color of the chip
   */
  color: PropTypes.string,
  /**
   * Color of the badge if any
   */
  badge: PropTypes.string,
  /**
   * Content of the chip
   */
  children: PropTypes.node,
  /**
   * Size of the chip
   */
  size: PropTypes.oneOf(sizes),
}

export default WinkingChip
